module.exports = __webpack_public_path__ + "static/media/empty.0a2978c5.png";